import momentTimezone from 'moment-timezone'
import 'moment/locale/en-gb'

momentTimezone.locale('en-gb')
export const moment = momentTimezone
